<payarc-dialog-shell title="Account access" (closed)="closeDialog()">
  <payarc-inline-alert variant="bad" class="aa-section" *ngIf="topErrorMessage">
    <div *ngFor="let msg of keys1">{{ msg }}</div>
  </payarc-inline-alert>
  <payarc-inline-alert variant="bad" class="aa-section" *ngIf="!topErrorMessage && errMsg">{{ errMsg }}</payarc-inline-alert>

  <input type="text" class="pa-input aa-account-filter" placeholder="Filter by name…" [(ngModel)]="searchText">
  <label class="aa-check">
    <input type="checkbox" #all (change)="selectAll(all.checked)"> Select all
  </label>
  <div class="aa-account-list">
    <label class="aa-check" *ngFor="let account of selectList | search:'account_name':searchText">
      <input type="checkbox" [(ngModel)]="account.selected">
      {{ account.dba_name ? account.dba_name + ' - ' : '' }}{{ account.account_name ? account.account_name : account.id }}
    </label>
  </div>

  <div footer class="aa-footer">
    <button type="button" payarcButton="secondary" (click)="closeDialog()">Cancel</button>
    <app-loading-button [buttonText]="'Save'" [loadFlag]="loadFlag" [disable]="!isSelected()" (buttonClick)="setRoles()"></app-loading-button>
  </div>
</payarc-dialog-shell>
